










import { formatDate } from "@/utils/luxon";
import { EntryDirection, EntryDtoType } from "@saysimple-platform/dtos";
import { defineComponent, PropType } from "@vue/composition-api";

export default defineComponent({
    props: {
        entry: {
            type: Object as PropType<EntryDtoType>,
            required: true,
        },
        groupDirection: {
            type: String as PropType<EntryDirection>,
            required: false,
        },
    },
    setup() {
        return {
            formatDate,
        };
    },
});
